import statsConfig_02_05_2019 from "./statsConfigs/statsConfig_02_05_2019";
import statsConfig_21_09_2017 from "./statsConfigs/statsConfig_21_09_2017";

/**
 * Created by intellicar-rinas on 21/9/17.
 */

let isHostHave =list=> {
    let host = window.location.href;
    for(let idx in list) {
        if(host.indexOf(list[idx]) !== -1) {
            return list[idx]
        }
    }
    return false;
}

export default ()=> {
    return statsConfig_02_05_2019;
}